/* Runtime du clone Lumea CoolMat.

   Le build retire les scripts du concurrent, dont Swiper : sans lui, les
   carrousels restent figés sur l'etat capture (classes swiper-* presentes,
   plus aucune mecanique). Ce fichier remplace Swiper par un moteur maison
   pilote par CAROUSELS, avec les memes reglages que ceux releves en direct
   sur la page d'origine (direction, slidesPerView par breakpoint, gouttiere).

   Aucun identifiant produit en dur : tout passe par window.TC_PRODUCT. */
(function () {
  var root = document.querySelector('.tc-clone');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* ---------- 1. Accordeons FAQ ---------- */
  function initFaq() {
    $$('.faq__summary').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height .28s ease';
      panel.style.height = btn.getAttribute('aria-expanded') === 'true'
        ? 'auto' : '0px';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.closest('.faq').classList.toggle('is-open', !open);
        panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
      });
    });
    /* Les accordeons sous le bloc d'achat n'ont ni <button> ni .accordion__title
       chez le concurrent : l'en-tete est un <h6 data-accordion-header>. Aucun
       ecouteur n'etait donc pose et les trois volets restaient fermes. */
    $$('.product-desc_accordion_item > [data-accordion-header], '
       + '.product-desc_accordion_item > button, '
       + '.product-desc_accordion_item .accordion__title').forEach(function (head) {
      var item = head.closest('.product-desc_accordion_item');
      var body = item.querySelector('[data-accordion-body], .product-desc_item_body');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      var toggle = function () {
        var open = item.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        /* le CSS du concurrent plafonne l'ouverture a 500 px : on suit la
           hauteur reelle, sinon les reponses longues sont tronquees */
        if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : '';
      };
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------- 2. Moteur de carrousel (remplace Swiper) ---------- */
  // spv/gap : { largeurMini: valeur }, evalues du plus grand au plus petit
  var CAROUSELS = [
    // les miniatures passent a l'horizontale sous 992 px, comme sur l'original
    { sel: '.product-thumbs-swiper', dir: { 0: 'x', 992: 'y' },
      spv: { 0: 4.4, 992: 5 }, gap: { 0: 10, 992: 15.6 } },
    // 'auto' = la largeur vient du CSS, ou la diapo est calee sur la largeur du
    // cadre (voir la surcharge en fin de tc-lumea-paws.css). Le pas de
    // defilement se deduit donc de la mesure reelle, sans debord.
    { sel: '.product-media-swiper', dir: 'x',
      spv: { 0: 'auto', 426: 1, 992: 'auto' }, gap: { 0: 10 },
      prev: '.product_main_prev', next: '.product_main_next',
      thumbs: '.product-thumbs-swiper' },
    { sel: '.product-description-swiper', dir: 'x',
      spv: { 0: 2.1, 506: 3, 992: 1, 1091: 2, 1461: 3 }, gap: { 0: 10 },
      prev: '.step_btn_prev', next: '.step_btn_next' },
    { sel: '.product__reviews_container', dir: 'x',
      spv: { 0: 1, 670: 2, 992: 1 }, gap: { 0: 10 },
      prev: '.card_btn_prev', next: '.card_btn_next' },
    { sel: '.tp-testimonials .swiper', dir: 'x',
      spv: { 0: 1.15, 700: 2, 990: 3 }, gap: { 0: 16, 990: 26 },
      prev: '.tp-button--prev', next: '.tp-button--next' }
  ];

  // une valeur simple ou une table { largeurMini: valeur }
  var atBreakpoint = function (map) {
    if (typeof map !== 'object' || map === null) return map;
    var w = window.innerWidth, best = null, bestBp = -1;
    Object.keys(map).forEach(function (bp) {
      if (w >= +bp && +bp > bestBp) { bestBp = +bp; best = map[bp]; }
    });
    return best;
  };

  function Carousel(el, cfg) {
    var wrap = el.querySelector(':scope > .swiper-wrapper');
    if (!wrap) return null;
    // Swiper duplique les slides en mode boucle : ces doublons figes feraient
    // doublon a l'ecran une fois sa mecanique partie
    $$('.swiper-slide-duplicate', el).forEach(function (n) { n.remove(); });

    var slides = $$(':scope > .swiper-slide', wrap);
    if (!slides.length) return null;
    var vertical = false;
    var index = 0, spv = 1, gap = 0, step = 0;

    el.style.overflow = 'hidden';
    wrap.style.cssText += ';display:flex;' +
      'transition:transform .38s cubic-bezier(.22,.61,.36,1);will-change:transform;' +
      'transform:none;overflow:visible;';

    function layout() {
      vertical = atBreakpoint(cfg.dir) === 'y';
      var want = atBreakpoint(cfg.spv) || 1;
      gap = atBreakpoint(cfg.gap) || 0;
      el.classList.toggle('swiper-vertical', vertical);
      el.classList.toggle('swiper-horizontal', !vertical);
      // le navigateur garde l'axe oppose : la page continue de defiler
      el.style.touchAction = vertical ? 'pan-x' : 'pan-y';
      wrap.style.flexDirection = vertical ? 'column' : 'row';
      wrap.style.gap = gap + 'px';

      var box = vertical ? el.clientHeight : el.clientWidth;
      var size;
      slides.forEach(function (s) {
        s.style.flex = '0 0 auto';
        s.style.transform = 'none';
        s.style.marginRight = '';
        s.style.marginBottom = '';
        // on efface d'abord : les largeurs figees par Swiper dans le capture
        // masqueraient la taille voulue par le CSS
        s.style.width = '';
        s.style.height = '';
      });

      if (want === 'auto') {
        // le CSS du theme pose la taille de la diapo ; on la lit au lieu de
        // l'imposer, en la bornant au conteneur pour ne rien rogner
        var css = slides[0].getBoundingClientRect()[vertical ? 'height' : 'width'];
        size = css > 0 ? Math.min(css, box) : box;
        if (css > box) {
          slides.forEach(function (s) {
            s.style[vertical ? 'height' : 'width'] = size + 'px';
          });
        }
      } else {
        size = (box - gap * (Math.ceil(want) - 1)) / want;
        slides.forEach(function (s) {
          s.style[vertical ? 'height' : 'width'] = size + 'px';
        });
      }

      step = size + gap;
      spv = step > 0 ? box / step : 1;
      go(index, true);
    }

    // nombre de diapos entierement visibles : on ne defile pas au-dela
    function maxIndex() {
      return Math.max(0, slides.length - Math.max(1, Math.floor(spv + 0.02)));
    }

    function go(i, instant) {
      index = Math.max(0, Math.min(maxIndex(), i));
      if (instant) wrap.style.transition = 'none';
      wrap.style.transform = vertical
        ? 'translate3d(0,' + (-index * step) + 'px,0)'
        : 'translate3d(' + (-index * step) + 'px,0,0)';
      if (instant) { wrap.offsetHeight; wrap.style.transition = ''; }
      slides.forEach(function (s, n) {
        s.classList.toggle('swiper-slide-active', n === index);
        s.classList.toggle('swiper-slide-next', n === index + 1);
        s.classList.toggle('swiper-slide-prev', n === index - 1);
        s.classList.toggle('swiper-slide-visible', n >= index && n < index + spv);
      });
      if (nav.prev) setDisabled(nav.prev, index <= 0);
      if (nav.next) setDisabled(nav.next, index >= maxIndex());
      el.dispatchEvent(new CustomEvent('tc:change', { detail: { index: index } }));
    }

    function setDisabled(btn, off) {
      btn.classList.toggle('swiper-button-disabled', off);
      btn.disabled = !!off;
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }

    // fleches : Swiper les pose hors du .swiper, on remonte au parent commun
    var scope = el.closest('section, .shopify-section, .swiper__media_container') || root;
    var nav = {
      prev: cfg.prev ? scope.querySelector(cfg.prev) : null,
      next: cfg.next ? scope.querySelector(cfg.next) : null
    };
    if (nav.prev) nav.prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    if (nav.next) nav.next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });

    var bullets = $$('.swiper-pagination-bullet', scope);
    bullets.forEach(function (b, i) {
      b.style.cursor = 'pointer';
      b.addEventListener('click', function () { go(i); });
    });
    if (bullets.length) {
      el.addEventListener('tc:change', function (e) {
        bullets.forEach(function (b, i) {
          b.classList.toggle('swiper-pagination-bullet-active', i === e.detail.index);
        });
      });
    }

    // glisser au doigt / a la souris
    var start = null, cross = 0, delta = 0, locked = null;
    var main = function (e) { return vertical ? e.clientY : e.clientX; };
    var side = function (e) { return vertical ? e.clientX : e.clientY; };
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      start = main(e); cross = side(e); delta = 0; locked = null;
      wrap.style.transition = 'none';
    });
    el.addEventListener('pointermove', function (e) {
      if (start === null) return;
      delta = main(e) - start;
      var off = side(e) - cross;
      // premier mouvement : on decide si le geste appartient au carrousel ou
      // au defilement de la page. Sans ca, tout scroll vertical fait riper
      // les diapos sur mobile.
      if (locked === null) {
        if (Math.abs(delta) < 6 && Math.abs(off) < 6) return;
        locked = Math.abs(delta) > Math.abs(off);
        if (!locked) { start = null; go(index); return; }
      }
      var base = -index * step + delta;
      wrap.style.transform = vertical
        ? 'translate3d(0,' + base + 'px,0)' : 'translate3d(' + base + 'px,0,0)';
    });
    var end = function () {
      if (start === null) return;
      wrap.style.transition = '';
      var moved = Math.abs(delta) > step * 0.18 ? (delta < 0 ? 1 : -1) : 0;
      start = null;
      go(index + moved);
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    layout();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(layout, 120);
    });

    return { el: el, go: go, layout: layout, count: slides.length,
      slides: slides, get index() { return index; },
      get visible() { return Math.max(1, Math.floor(spv + 0.02)); } };
  }

  var carousels = {};
  function initCarousels() {
    CAROUSELS.forEach(function (cfg) {
      $$(cfg.sel).forEach(function (el) {
        var c = Carousel(el, cfg);
        if (c) carousels[cfg.sel] = c;
      });
    });

    // galerie : miniatures <-> visuel principal, dans les deux sens
    var main = carousels['.product-media-swiper'];
    var thumbs = carousels['.product-thumbs-swiper'];
    if (!main) return;
    var marks = thumbs ? thumbs.slides : $$('.product-thumbs-swiper .swiper-slide');
    marks.forEach(function (t, i) {
      t.style.cursor = 'pointer';
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      var pick = function () { main.go(i); };
      t.addEventListener('click', pick);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });
    main.el.addEventListener('tc:change', function (e) {
      var i = e.detail.index;
      marks.forEach(function (t, n) {
        t.classList.toggle('swiper-slide-thumb-active', n === i);
      });
      // garde la miniature active dans la fenetre visible
      if (thumbs && (i < thumbs.index || i >= thumbs.index + thumbs.visible)) {
        thumbs.go(i - Math.floor(thumbs.visible / 2));
      }
    });
    main.go(0, true);
  }

  /* ---------- 3. Guide des tailles (modale) ---------- */
  function initSizeGuide() {
    var modal = $('.lumea-size-guide__modal');
    var overlay = $('.lumea-size-guide__overlay');
    if (!modal) return;
    var last = null;
    var open = function (e) {
      if (e) e.preventDefault();
      last = document.activeElement;
      [modal, overlay].forEach(function (n) {
        if (!n) return;
        n.classList.add('is-open');
        n.setAttribute('aria-hidden', 'false');
      });
      root.classList.add('lumea-size-guide-is-open');
      document.body.style.overflow = 'hidden';
      var card = $('.lumea-size-guide__card', modal);
      if (card) card.focus();
    };
    var close = function (e) {
      if (e) e.preventDefault();
      [modal, overlay].forEach(function (n) {
        if (!n) return;
        n.classList.remove('is-open');
        n.setAttribute('aria-hidden', 'true');
      });
      root.classList.remove('lumea-size-guide-is-open');
      document.body.style.overflow = '';
      if (last && last.focus) last.focus();
    };
    close();
    $$('.lumea-size-guide__trigger').forEach(function (b) { b.addEventListener('click', open); });
    $$('.lumea-size-guide__close').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---------- 4. Compte a rebours ---------- */
  function initCountdown() {
    var bar = $('.lumea-countdown-bar');
    if (!bar) return;
    var digits = $$('.lumea-countdown-bar__digits', bar);
    if (digits.length < 3) return;
    var resetHour = parseInt(bar.getAttribute('data-reset-hours') || '13', 10);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now);
      end.setHours(resetHour, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      digits[0].textContent = pad(Math.floor(s / 3600));
      digits[1].textContent = pad(Math.floor((s % 3600) / 60));
      digits[2].textContent = pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- 5. Comparateur avant / apres ---------- */
  function initBeforeAfter() {
    var box = $('.before-after-slider-container');
    if (!box) return;
    var after = $('.after-image', box);
    var line = $('.slider-line', box);
    var icon = $('.slider-icon', box);
    var input = $('input.slider', box);
    if (!after) return;
    var set = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      if (line) line.style.left = pct + '%';
      if (icon) { icon.style.left = pct + '%'; icon.style.transform = 'translate(-50%, -50%)'; }
      if (input) input.value = pct;
    };
    set(50);
    var dragging = false;
    var move = function (clientX) {
      var r = box.getBoundingClientRect();
      set(((clientX - r.left) / r.width) * 100);
    };
    box.style.touchAction = 'pan-y';
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      move(e.clientX);
      // la capture n'est qu'un confort : si elle echoue, le glissement doit
      // quand meme repondre
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
    });
    // suivi au niveau de la fenetre : le doigt sort souvent du cadre en cours
    // de glissement, et la capture de pointeur peut ne pas etre accordee
    window.addEventListener('pointermove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointercancel', function () { dragging = false; });
    if (input) {
      input.addEventListener('input', function () { set(+input.value); });
      input.setAttribute('aria-label', 'Comparer avec et sans le tapis');
    }
  }

  /* ---------- 6. « Ce qui fait la difference » : puces numerotees ---------- */
  function initNumbered() {
    var dots = $$('.nc-dot');
    if (!dots.length) return;
    var card = document.getElementById(dots[0].getAttribute('aria-controls'));
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        dots.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        d.setAttribute('aria-selected', 'true');
        if (!card) return;
        var img = card.querySelector('img');
        var tit = card.querySelector('.nc-card__title, h3, h4');
        var desc = card.querySelector('.nc-card__desc, p');
        if (img && d.dataset.img) { img.src = d.dataset.img; if (d.dataset.img2x) img.srcset = d.dataset.img2x; }
        if (tit && d.dataset.title) tit.textContent = d.dataset.title;
        if (desc && d.dataset.desc) desc.textContent = d.dataset.desc;
      });
    });
  }

  /* ---------- 7. Formulaire d'achat du theme (repli) ---------- */
  function initForm() {
    var form = $('form[action*="/cart/add"]');
    if (!form) return;
    ['product-id', 'section-id', 'selling_plan'].forEach(function (n) {
      var el = form.querySelector('[name="' + n + '"]');
      if (el) el.remove();
    });
    var qty = form.querySelector('[name="quantity"]');
    if (qty) qty.value = '1';

    var P = window.TC_PRODUCT;
    var idInput = form.querySelector('[name="id"]');
    if (!P || !P.variants || !P.variants.length || !idInput) return;
    var firstAvailable = P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    idInput.value = firstAvailable.id;
  }

  /* ---------- 8. Barre d'achat collante ---------- */
  function initStickyBar() {
    var bar = $('[data-stickygp]');
    var offer = $('[data-cm-offer]');
    if (!bar || !offer) return;
    bar.removeAttribute('hidden');
    bar.setAttribute('aria-hidden', 'false');
    bar.style.display = '';
    var btn = $('[data-sticky-gp-atc]', bar);
    if (btn) {
      btn.removeAttribute('data-variant-id');
      btn.addEventListener('click', function () {
        // meme parcours que le bouton principal : on garde une seule logique
        if (window.TC_OFFER_ADD) return window.TC_OFFER_ADD();
        offer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    // visible une fois le bloc d'offre passe, masquee avant.
    // La translation est posee en style inline : le theme applique deja un
    // transform sur cette barre, une classe se ferait ecraser.
    bar.style.position = 'fixed';
    bar.style.left = '0';
    bar.style.right = '0';
    bar.style.bottom = '0';
    bar.style.transition = 'transform .28s ease';
    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.style.transform = on ? 'translateY(0)' : 'translateY(120%)';
    };
    // ecoute du defilement plutot qu'un IntersectionObserver : l'observateur
    // ne redeclenchait pas de facon fiable sur cette page
    var sync = function () { show(offer.getBoundingClientRect().bottom < 0); };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
  }

  function boot() {
    [initFaq, initCarousels, initSizeGuide, initCountdown,
     initBeforeAfter, initNumbered, initForm, initStickyBar].forEach(function (fn) {
      try { fn(); } catch (e) { console.warn('[tc-clone]', fn.name, e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
